import { render, staticRenderFns } from "./BlockBlockQuote.vue?vue&type=template&id=e24c0f62&"
import script from "./BlockBlockQuote.vue?vue&type=script&lang=js&"
export * from "./BlockBlockQuote.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlockQuote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports